import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import OfferBar from '../../../../components/offer_Container';
import Links from '../../../../components/navbar_links';
import { useSelector, useDispatch } from 'react-redux';
import { removeItemFromCart, addToCart } from '../../../../actions/cart';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { headersearch } from '../../../../components/utils/LoadScript';
const MainHeaderThree = props => {
  useEffect(() => {
    // for load search
    headersearch();

    // get langauge from localStorage and change the direction if language is arabic
    const langauge = localStorage.getItem('i18nextLng');
    
    if (langauge === 'ar') {
      document.body.classList.add('bodyrtl');
    } else {
      document.body.classList.remove('bodyrtl');
    }
  }, []);

  // for language excahnger
  const { t, i18n } = useTranslation();
  
  
  
  // select product from reducer cart
  const products = useSelector(state => state.cart.products);
  const total = useSelector(state => state.cart.total);
  // for dispatch the function
  const dispatch = useDispatch();
  // length of product in cart
  const length = products.length;
  // for show alert
  const alert = useAlert();
  // get all wishlist product from redux
  const WishlistProducts = useSelector(state => state.cart.Wishlist_Products);
  // get the length of the wishlist product
  const wishlistProductLenght = WishlistProducts.length;

  // state to check that currency change state is present or not
  const [isCurrencyPresent, setCurrencyPresent] = useState(true);

  // for switch language
  const handleClick = lang => {
    i18n.changeLanguage(lang);
    // change the direction to rtl if lang is arabic
    if (lang === 'ar') {
      document.body.classList.add('bodyrtl');
    } else {
      document.body.classList.remove('bodyrtl');
    }
  };

  // for delete the product form cart or list
  const confirmDelete = (index, item) => {
    dispatch(removeItemFromCart(index, item));
    dispatch(addToCart());
    alert.error('Delected successfully!');
  };

  const language = localStorage.getItem('i18nextLng');
  return (
    <Fragment>
      <header
        id='headerThree'
        className='header-area header-three header-desktop'
      >
        {/* offer bar component */}
        <OfferBar />
        <div className='header-maxi bg-header-bar'>
          <div className='container'>
            <div className='row align-items-center'>
              <div className='col-12 col-sm-12 col-lg-3'>
                <div className='navbar-lang'>
                  <div className='dropdown'>
                    <a
                      href='javascript:void(0);'
                      className='dropdown-toggle'
                    >
                      {language === 'en' ? 'English' : 'عربى'}
                    </a>
                    <div className='dropdown-menu'>
                      <a
                        className='dropdown-item'
                        to='#'
                        onClick={() => handleClick('en')}
                      >
                        English
                      </a>
                      <a
                        className='dropdown-item'
                        to='#'
                        onClick={() => handleClick('ar')}
                      >
                        {t('Arabic.1')}
                      </a>
                    </div>
                  </div>
                  <div className='dropdown'>
                    <Link
                      href='javascript:void(0);'
                      className='dropdown-toggle'
                    >
                      {props.currencyDetails.code}
                    </Link>
                    <div className='dropdown-menu'>
                      <a
                        className='dropdown-item'
                        href='#'
                        onClick={() => props.onCurrencyChanged(0)}
                      >
                        $&nbsp;USD
                      </a>
                      <a
                        className='dropdown-item'
                        href='#'
                        onClick={() => props.onCurrencyChanged(1)}
                      >
                        €&nbsp;EURO
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-sm-6 pro-logo'>
                <Link
                  to='/'
                  className='logo'
                  data-toggle='tooltip'
                  data-placement='bottom'
                  title='logo'
                >
                  <img
                    className='img-fuild'
                    src='assets/images/logo/logo.png'
                    alt='logo here'
                  />
                </Link>
              </div>
              <div className='col-6 col-sm-6 col-md-4 col-lg-3'>
                <ul className='pro-header-right-options'>
                  <li className='dropdown'>
                    <button
                      id='dropdownSearch'
                      type='button'
                      className='btn dropdown-toggle'
                    >
                      <i className='fas fa-search' />
                    </button>
                    <div
                      id='dropdown-searchbar'
                      className='dropdown-searchbar'
                      style={{ display: 'none' }}
                    >
                      <div className='container'>
                        <div className='pro-col'>
                          <button type='button' className='close'>
                            <span aria-hidden='true'>×</span>
                          </button>
                          <div className='pro-info-text'>
                            {t('What are you Looking for?.1')}
                          </div>
                          <div className='pro-search-wrap'>
                            <input
                              type='text'
                              className='pro-search-input'
                              placeholder={t('Search Products.1')}
                            />
                            <button
                              className='btn pro-btn-search'
                              type='submit'
                            >
                              <i className='fas fa-search' />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <Link
                      to='/wishlist'
                      className='btn'
                      data-toggle='tooltip'
                      data-placement='bottom'
                      title='Wishlist'
                    >
                      <i className='far fa-heart' />
                      <span className='badge badge-secondary'>
                        {wishlistProductLenght}
                      </span>
                    </Link>
                  </li>
                  <li
                    className='cart-header dropdown head-cart-content'
                    data-toggle='tooltip'
                    data-placement='bottom'
                    title='cart'
                  >
                    <button
                      type='button'
                      id='dropdownCart'
                      className='btn dropdown-toggle'
                      aria-haspopup='true'
                      aria-expanded='false'
                      data-toggle='dropdown'
                    >
                      <i className='fas fa-shopping-cart' />
                      <span className='badge badge-secondary'>{length}</span>
                    </button>
                    <div
                      className='dropdown-menu dropdown-menu-right'
                      aria-labelledby='dropdownCart'
                    >
                      {length === 0 ||
                      length === null ||
                      length === undefined ? (
                        <ul>
                        <li>
                          {t('your cart is empty please please add product.1')}!
                        </li>
                      </ul>
                      ) : (
                        <ul className='shopping-cart-items'>
                          {products !== undefined && products !== null
                            ? products.map((item, index) => (
                                <li>
                                  <div className='item-thumb'>
                                    <div className='image'>
                                      <img
                                        className='img-fluid'
                                        src={item.products_image}
                                        alt='Product'
                                      />
                                    </div>
                                  </div>
                                  <div className='item-detail'>
                                    <h2>{t(`${item.products_name}.1`)}</h2>
                                    <div className='item-s'>
                                      {item.quantity} x{' '}
                                      {props.currencyDetails.symbolLeft}
                                      {(
                                        item.products_price *
                                        props.currencyDetails.value
                                      ).toFixed(2)}
                                      <i
                                        className='fas fa-trash'
                                        onClick={() =>
                                          confirmDelete(index, item)
                                        }
                                      />
                                    </div>
                                  </div>
                                </li>
                              ))
                            : null}

                          <li>
                            <span className='item-summary'>
                              {t('Total.1')}&nbsp;:&nbsp;
                              <span>
                                {props.currencyDetails.symbolLeft}
                                {(total * props.currencyDetails.value).toFixed(
                                  2
                                )}
                              </span>
                            </span>
                          </li>
                          <li>
                            <Link
                              className='btn  btn-link btn-block hvr-sweep-to-top'
                              to='/cart-page1'
                            >
                              {t('View Cart.1')}
                            </Link>
                            <Link
                              className='btn btn-secondary btn-block  hvr-sweep-to-top'
                              to='/checkout'
                            >
                              {t('Checkout.1')}
                            </Link>
                          </li>
                        </ul>
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='header-navbar bg-menu-bar'>
          <div className='container'>
            <Links />
          </div>
        </div>
      </header>
    </Fragment>
  );
};

export default MainHeaderThree;
